// Shared roster predicates.
//
// THE ONE DEFINITION of "can this person be put on a job on the scheduling board".
//
// 'active' and 'schedulable' answer DIFFERENT questions and must never be conflated:
//   active      — is this person on the roster at all? Office staff (PMs, owners, admins,
//                 drivers) are deliberately active = true so they appear on the Roster and
//                 Time Off screens, on field reports, and in the texting audience.
//   schedulable — can they be assigned crew on the board? False for office staff.
//                 See employees.schedulable (supabase-employee-schedulable.sql).
//
// ⚠ SCOPE: this governs PICKERS and AVAILABLE-CREW lists only — the crew picker, the
// foreman dropdowns, and the "Unassigned" lists. Someone already SAVED on a schedule_cells
// row must still render on the board, in Who's Where, on the field report and in the
// schedule email exactly as before. If an office person worked a Saturday last month, that
// assignment does not disappear because they are now flagged off-board.
//
// Both flags default to TRUE when absent (`!== false`), so a roster row that predates the
// column, or a shape built from data.js defaults, is schedulable.
export const isSchedulable = (e) => !!e && e.active !== false && e.schedulable !== false
